import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], total: 0, error: "", message: "" }


export const allDeviceInfoAction = createAsyncThunk(
    'all-device-info',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/all-userDevicesInfo?page=${data.page}&limit=${data.pageSize}&userId=${data.userId}&startDate=${data.startDate}&endDate=${data.endDate}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const allDeviceInfoSlice = createSlice({
    name: 'all-device-info',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(allDeviceInfoAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(allDeviceInfoAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totatCount
            })
            builder.addCase(allDeviceInfoAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const allDeviceInfoReducer = allDeviceInfoSlice.reducer